"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ontarioCities = void 0;
exports.ontarioCities = [
    {
        label: "Aberfoyl",
        value: 3001,
    },
    {
        label: "Acton",
        value: 3002,
    },
    {
        label: "Agincourt",
        value: 3003,
    },
    {
        label: "Ailsa Craig",
        value: 3004,
    },
    {
        label: "Ajax",
        value: 3006,
    },
    {
        label: "Aldershot",
        value: 3007,
    },
    {
        label: "Alderwood",
        value: 3009,
    },
    {
        label: "Alexandria",
        value: 3008,
    },
    {
        label: "Alfred",
        value: 3010,
    },
    {
        label: "Algoma",
        value: 3011,
    },
    {
        label: "Algoma Mills",
        value: 3013,
    },
    {
        label: "Allenford",
        value: 3941,
    },
    {
        label: "Alliston",
        value: 3012,
    },
    {
        label: "Alma, ON",
        value: 3005,
    },
    {
        label: "Almonte",
        value: 3014,
    },
    {
        label: "Alton",
        value: 3015,
    },
    {
        label: "Alvinston",
        value: 3016,
    },
    {
        label: "Amherstburg",
        value: 3018,
    },
    {
        label: "Amherstview",
        value: 3995,
    },
    {
        label: "Ancaster",
        value: 3326,
    },
    {
        label: "Anderson",
        value: 3017,
    },
    {
        label: "Angus",
        value: 3019,
    },
    {
        label: "Annan",
        value: 3000,
    },
    {
        label: "Apple Hill",
        value: 3285,
    },
    {
        label: "Apsley",
        value: 3255,
    },
    {
        label: "Ariss",
        value: 3021,
    },
    {
        label: "Arkona",
        value: 3020,
    },
    {
        label: "Armitage",
        value: 3023,
    },
    {
        label: "Armstrong, ON",
        value: 3025,
    },
    {
        label: "Arnprior",
        value: 3022,
    },
    {
        label: "Arnstein",
        value: 3027,
    },
    {
        label: "Arthur",
        value: 3024,
    },
    {
        label: "Arva",
        value: 3287,
    },
    {
        label: "Ashburn",
        value: 3029,
    },
    {
        label: "Ashton",
        value: 3031,
    },
    {
        label: "Athens",
        value: 3026,
    },
    {
        label: "Atikokan",
        value: 3033,
    },
    {
        label: "Attawapiskat",
        value: 3288,
    },
    {
        label: "Atwood",
        value: 3943,
    },
    {
        label: "Auburn",
        value: 3944,
    },
    {
        label: "Aurora",
        value: 3028,
    },
    {
        label: "Avon",
        value: 3034,
    },
    {
        label: "Avonmore",
        value: 3942,
    },
    {
        label: "Aylmer, ON",
        value: 3030,
    },
    {
        label: "Ayr",
        value: 3032,
    },
    {
        label: "Azilda, ON",
        value: 3113,
    },
    {
        label: "Baden, ON",
        value: 3114,
    },
    {
        label: "Bailieboro",
        value: 3289,
    },
    {
        label: "Bainsville",
        value: 3035,
    },
    {
        label: "Bala",
        value: 3036,
    },
    {
        label: "Baldwin",
        value: 3037,
    },
    {
        label: "Ballantree",
        value: 3038,
    },
    {
        label: "Balmertown",
        value: 3039,
    },
    {
        label: "Baltimore",
        value: 3045,
    },
    {
        label: "Bamkanen",
        value: 3041,
    },
    {
        label: "Bancroft",
        value: 3040,
    },
    {
        label: "Bar Harbour",
        value: 3043,
    },
    {
        label: "Barrie",
        value: 3042,
    },
    {
        label: "Barry's Bay",
        value: 3044,
    },
    {
        label: "Basswood Lake",
        value: 3047,
    },
    {
        label: "Batawa",
        value: 3049,
    },
    {
        label: "Bath, ON",
        value: 3046,
    },
    {
        label: "Battersea",
        value: 3315,
    },
    {
        label: "Bayfield",
        value: 3048,
    },
    {
        label: "Baymouth",
        value: 3051,
    },
    {
        label: "Baysville",
        value: 3053,
    },
    {
        label: "Beachburg",
        value: 3050,
    },
    {
        label: "Beachville",
        value: 3052,
    },
    {
        label: "Beamsville",
        value: 3055,
    },
    {
        label: "Beardmore",
        value: 3057,
    },
    {
        label: "Beaverton",
        value: 3054,
    },
    {
        label: "Beeton",
        value: 3056,
    },
    {
        label: "Belfountain",
        value: 3059,
    },
    {
        label: "Bell Ewart",
        value: 3570,
    },
    {
        label: "Belle River",
        value: 3058,
    },
    {
        label: "Belleville",
        value: 3060,
    },
    {
        label: "Belmont, ON",
        value: 3062,
    },
    {
        label: "Belwood",
        value: 3105,
    },
    {
        label: "Berkeley",
        value: 3065,
    },
    {
        label: "Bethany",
        value: 3079,
    },
    {
        label: "Binbrook",
        value: 3067,
    },
    {
        label: "Blackburn Hamlet",
        value: 3063,
    },
    {
        label: "Blackstock",
        value: 3081,
    },
    {
        label: "Blenheim",
        value: 3064,
    },
    {
        label: "Blind River",
        value: 3066,
    },
    {
        label: "Bloomfield, ON",
        value: 3068,
    },
    {
        label: "Bloomingdale",
        value: 3571,
    },
    {
        label: "Bluevale",
        value: 3069,
    },
    {
        label: "Blyth",
        value: 3070,
    },
    {
        label: "Bobcaygeon",
        value: 3072,
    },
    {
        label: "Bob-Lo Island",
        value: 3073,
    },
    {
        label: "Bolton",
        value: 3074,
    },
    {
        label: "Bond Head",
        value: 3071,
    },
    {
        label: "Bonfield",
        value: 3076,
    },
    {
        label: "Borden, ON",
        value: 3077,
    },
    {
        label: "Bothwell",
        value: 3078,
    },
    {
        label: "Bourget, ON",
        value: 3115,
    },
    {
        label: "Bowmanville",
        value: 3080,
    },
    {
        label: "Bracebridge",
        value: 3082,
    },
    {
        label: "Bradford",
        value: 3084,
    },
    {
        label: "Braeside",
        value: 3086,
    },
    {
        label: "Bramalea",
        value: 3087,
    },
    {
        label: "Brampton",
        value: 3088,
    },
    {
        label: "Branchton",
        value: 3089,
    },
    {
        label: "Brantford",
        value: 3090,
    },
    {
        label: "Brechin",
        value: 3085,
    },
    {
        label: "Breslau",
        value: 3091,
    },
    {
        label: "Bridgenorth",
        value: 3535,
    },
    {
        label: "Bridgeport",
        value: 3092,
    },
    {
        label: "Brigden",
        value: 3572,
    },
    {
        label: "Bright",
        value: 3093,
    },
    {
        label: "Brighton",
        value: 3094,
    },
    {
        label: "Bright's Grove",
        value: 3095,
    },
    {
        label: "Britt",
        value: 3573,
    },
    {
        label: "Brockville",
        value: 3096,
    },
    {
        label: "Bronte",
        value: 3097,
    },
    {
        label: "Brooklin, ON",
        value: 3116,
    },
    {
        label: "Brownsville",
        value: 3075,
    },
    {
        label: "Bruce Mines",
        value: 3098,
    },
    {
        label: "Brunner",
        value: 3099,
    },
    {
        label: "Brussels",
        value: 3100,
    },
    {
        label: "Buckhorn",
        value: 3539,
    },
    {
        label: "Burford",
        value: 3103,
    },
    {
        label: "Burgessville",
        value: 3101,
    },
    {
        label: "Burk's Falls",
        value: 3102,
    },
    {
        label: "Burlington",
        value: 3104,
    },
    {
        label: "Burnt River",
        value: 3106,
    },
    {
        label: "Burritts Rapids",
        value: 3108,
    },
    {
        label: "Buttonville",
        value: 3110,
    },
    {
        label: "Cabden",
        value: 3118,
    },
    {
        label: "Cache Bay",
        value: 3120,
    },
    {
        label: "Caesarea",
        value: 3119,
    },
    {
        label: "Caistor Centre",
        value: 3121,
    },
    {
        label: "Caledon",
        value: 3123,
    },
    {
        label: "Caledon East",
        value: 3122,
    },
    {
        label: "Caledon Village",
        value: 3319,
    },
    {
        label: "Caledonia, ON",
        value: 3124,
    },
    {
        label: "Callander",
        value: 3127,
    },
    {
        label: "Cambridge",
        value: 3129,
    },
    {
        label: "Cambridge-Galt",
        value: 3126,
    },
    {
        label: "Cameron",
        value: 3574,
    },
    {
        label: "Camlachie",
        value: 3182,
    },
    {
        label: "Campbellcroft",
        value: 3131,
    },
    {
        label: "Campbellford",
        value: 3128,
    },
    {
        label: "Campbellville",
        value: 3133,
    },
    {
        label: "Canfield",
        value: 3183,
    },
    {
        label: "Cannington",
        value: 3130,
    },
    {
        label: "Capreol",
        value: 3132,
    },
    {
        label: "Caramat",
        value: 3135,
    },
    {
        label: "Cardinal",
        value: 3134,
    },
    {
        label: "Cardwal",
        value: 3137,
    },
    {
        label: "Carleton Place",
        value: 3136,
    },
    {
        label: "Carlisle",
        value: 3139,
    },
    {
        label: "Carlsbad Springs",
        value: 3321,
    },
    {
        label: "Carp",
        value: 3141,
    },
    {
        label: "Carrying Place",
        value: 3117,
    },
    {
        label: "Casselman",
        value: 3138,
    },
    {
        label: "Castleton",
        value: 3266,
    },
    {
        label: "Cavan",
        value: 3323,
    },
    {
        label: "Cayuga, ON",
        value: 3195,
    },
    {
        label: "Cedar Valley",
        value: 3143,
    },
    {
        label: "Central Elgin",
        value: 3568,
    },
    {
        label: "Centralia",
        value: 3145,
    },
    {
        label: "Chaffey's Lock",
        value: 3325,
    },
    {
        label: "Chalk River",
        value: 3140,
    },
    {
        label: "Chapleau",
        value: 3147,
    },
    {
        label: "Charing Cross",
        value: 3149,
    },
    {
        label: "Charlesbourg, ON",
        value: 3151,
    },
    {
        label: "Charlton",
        value: 3142,
    },
    {
        label: "Chatham, ON",
        value: 3144,
    },
    {
        label: "Chatsworth",
        value: 3146,
    },
    {
        label: "Chelmsford",
        value: 3153,
    },
    {
        label: "Cheltenham",
        value: 3155,
    },
    {
        label: "Chesley",
        value: 3148,
    },
    {
        label: "Chesterville, ON",
        value: 3150,
    },
    {
        label: "Churchill, ON",
        value: 3157,
    },
    {
        label: "Claremount, ON",
        value: 3159,
    },
    {
        label: "Clarendon",
        value: 3161,
    },
    {
        label: "Clarkson",
        value: 3541,
    },
    {
        label: "Clearwater, ON",
        value: 3163,
    },
    {
        label: "Clifford",
        value: 3152,
    },
    {
        label: "Clinton, ON",
        value: 3154,
    },
    {
        label: "Coatsworth",
        value: 3165,
    },
    {
        label: "Cobalt",
        value: 3156,
    },
    {
        label: "Cobden",
        value: 3158,
    },
    {
        label: "Cobourg",
        value: 3160,
    },
    {
        label: "Cochrane, ON",
        value: 3162,
    },
    {
        label: "Colborne",
        value: 3164,
    },
    {
        label: "Coldwater",
        value: 3166,
    },
    {
        label: "Colgan",
        value: 3167,
    },
    {
        label: "Collingwood",
        value: 3168,
    },
    {
        label: "Combermere",
        value: 3169,
    },
    {
        label: "Comlachie",
        value: 3171,
    },
    {
        label: "Concord",
        value: 3173,
    },
    {
        label: "Conestogo",
        value: 3245,
    },
    {
        label: "Coniston",
        value: 3170,
    },
    {
        label: "Conn",
        value: 3184,
    },
    {
        label: "Connaught",
        value: 3175,
    },
    {
        label: "Consecon",
        value: 3177,
    },
    {
        label: "Cookstown",
        value: 3172,
    },
    {
        label: "Copper Cliff",
        value: 3174,
    },
    {
        label: "Corbeil",
        value: 3555,
    },
    {
        label: "Cornwall, ON",
        value: 3176,
    },
    {
        label: "Corunna",
        value: 3185,
    },
    {
        label: "Cottam",
        value: 3179,
    },
    {
        label: "Courtice",
        value: 3107,
    },
    {
        label: "Courtland",
        value: 3189,
    },
    {
        label: "Courtright",
        value: 3178,
    },
    {
        label: "Creemore",
        value: 3180,
    },
    {
        label: "Crofton, ON",
        value: 3181,
    },
    {
        label: "Crysler",
        value: 3109,
    },
    {
        label: "Crystal Beach",
        value: 3111,
    },
    {
        label: "Cumberland, ON",
        value: 3186,
    },
    {
        label: "Curran",
        value: 3187,
    },
    {
        label: "Curve Lake",
        value: 3188,
    },
    {
        label: "Cutterville",
        value: 3112,
    },
    {
        label: "Dashwood",
        value: 3191,
    },
    {
        label: "Deep River",
        value: 3190,
    },
    {
        label: "Delaware",
        value: 3327,
    },
    {
        label: "Delhi",
        value: 3196,
    },
    {
        label: "Deloro",
        value: 3198,
    },
    {
        label: "Denfield",
        value: 3192,
    },
    {
        label: "Desbarats",
        value: 3197,
    },
    {
        label: "Deseronto",
        value: 3200,
    },
    {
        label: "Devlin",
        value: 3199,
    },
    {
        label: "Dinbrook",
        value: 3205,
    },
    {
        label: "Don Mills",
        value: 3201,
    },
    {
        label: "Dorchester, ON",
        value: 3212,
    },
    {
        label: "Downs",
        value: 3207,
    },
    {
        label: "Downsview",
        value: 3203,
    },
    {
        label: "Drayton",
        value: 3202,
    },
    {
        label: "Dresden",
        value: 3204,
    },
    {
        label: "Dryden",
        value: 3206,
    },
    {
        label: "Dublin",
        value: 3193,
    },
    {
        label: "Dufferin",
        value: 3211,
    },
    {
        label: "Dunchurch",
        value: 3559,
    },
    {
        label: "Dundalk",
        value: 3210,
    },
    {
        label: "Dundas",
        value: 3328,
    },
    {
        label: "Dunnville, ON",
        value: 3214,
    },
    {
        label: "Dunrobin",
        value: 3194,
    },
    {
        label: "Dunsford",
        value: 3575,
    },
    {
        label: "Dunvegan",
        value: 3219,
    },
    {
        label: "Durham, ON",
        value: 3216,
    },
    {
        label: "Dutton",
        value: 3218,
    },
    {
        label: "Dwight",
        value: 3213,
    },
    {
        label: "Dwyer Hill",
        value: 3215,
    },
    {
        label: "E Gwillimbury",
        value: 3217,
    },
    {
        label: "Eagle River",
        value: 3222,
    },
    {
        label: "Ear Falls",
        value: 3224,
    },
    {
        label: "East York",
        value: 3818,
    },
    {
        label: "Echo Bay",
        value: 3226,
    },
    {
        label: "Eden",
        value: 3228,
    },
    {
        label: "Eganville",
        value: 3230,
    },
    {
        label: "Elgin, ON",
        value: 3229,
    },
    {
        label: "Elizabethtown",
        value: 3329,
    },
    {
        label: "Elliot Lake",
        value: 3231,
    },
    {
        label: "Elmida",
        value: 3233,
    },
    {
        label: "Elmira",
        value: 3232,
    },
    {
        label: "Elmvale",
        value: 3234,
    },
    {
        label: "Elmwood",
        value: 3235,
    },
    {
        label: "Elora",
        value: 3236,
    },
    {
        label: "Embro",
        value: 3238,
    },
    {
        label: "Embrun",
        value: 3239,
    },
    {
        label: "Emo",
        value: 3237,
    },
    {
        label: "Englehart",
        value: 3240,
    },
    {
        label: "Enniskillen",
        value: 3243,
    },
    {
        label: "Ennismore",
        value: 3241,
    },
    {
        label: "Erie Beach",
        value: 3242,
    },
    {
        label: "Erieau",
        value: 3244,
    },
    {
        label: "Erin",
        value: 3246,
    },
    {
        label: "Espanola",
        value: 3248,
    },
    {
        label: "Essex",
        value: 3250,
    },
    {
        label: "Etobicoke",
        value: 3819,
    },
    {
        label: "Everett",
        value: 3254,
    },
    {
        label: "Exeter",
        value: 3256,
    },
    {
        label: "Fenelon Falls",
        value: 3270,
    },
    {
        label: "Fenwick, ON",
        value: 3220,
    },
    {
        label: "Fergus",
        value: 3272,
    },
    {
        label: "Finch",
        value: 3274,
    },
    {
        label: "Fisherville",
        value: 3273,
    },
    {
        label: "Fitzroy Harbour",
        value: 3271,
    },
    {
        label: "Flamborough",
        value: 3275,
    },
    {
        label: "Flesherton",
        value: 3276,
    },
    {
        label: "Floradale",
        value: 3277,
    },
    {
        label: "Florence",
        value: 3281,
    },
    {
        label: "Fonthill",
        value: 3279,
    },
    {
        label: "Forest",
        value: 3278,
    },
    {
        label: "Forks of the Credit",
        value: 3125,
    },
    {
        label: "Fort Albany",
        value: 3623,
    },
    {
        label: "Fort Erie",
        value: 3280,
    },
    {
        label: "Fort Frances",
        value: 3282,
    },
    {
        label: "Frankford",
        value: 3284,
    },
    {
        label: "Freelton",
        value: 3283,
    },
    {
        label: "Fruitland",
        value: 3286,
    },
    {
        label: "Fullarton",
        value: 3337,
    },
    {
        label: "Gananoque",
        value: 3290,
    },
    {
        label: "Garson, ON",
        value: 3292,
    },
    {
        label: "Georgetown, ON",
        value: 3294,
    },
    {
        label: "Georgian Bay",
        value: 3291,
    },
    {
        label: "Geraldton",
        value: 3296,
    },
    {
        label: "Gilford",
        value: 3297,
    },
    {
        label: "Girouxville, ON",
        value: 3317,
    },
    {
        label: "Glen Robertson",
        value: 3945,
    },
    {
        label: "Glen William",
        value: 3299,
    },
    {
        label: "Glencoe",
        value: 3298,
    },
    {
        label: "Gloucester",
        value: 3301,
    },
    {
        label: "Goderich",
        value: 3300,
    },
    {
        label: "Godfrey",
        value: 3303,
    },
    {
        label: "Golden Lake",
        value: 3338,
    },
    {
        label: "Goodwood",
        value: 3295,
    },
    {
        label: "Gore Bay",
        value: 3302,
    },
    {
        label: "Gores Landing",
        value: 3461,
    },
    {
        label: "Gormley",
        value: 3305,
    },
    {
        label: "Goulais",
        value: 3307,
    },
    {
        label: "Gowanstown",
        value: 3309,
    },
    {
        label: "Grafton",
        value: 3311,
    },
    {
        label: "Grand Bend",
        value: 3304,
    },
    {
        label: "Grand Valley",
        value: 3306,
    },
    {
        label: "Granton",
        value: 3293,
    },
    {
        label: "Grassie",
        value: 3313,
    },
    {
        label: "Grassy Narrows",
        value: 3576,
    },
    {
        label: "Gravenhurst",
        value: 3308,
    },
    {
        label: "Greely",
        value: 3314,
    },
    {
        label: "Griffith",
        value: 3316,
    },
    {
        label: "Grimsby",
        value: 3310,
    },
    {
        label: "Guelph",
        value: 3312,
    },
    {
        label: "Hagersville",
        value: 3320,
    },
    {
        label: "Haileybury",
        value: 3322,
    },
    {
        label: "Haliburton",
        value: 3333,
    },
    {
        label: "Halton Hills",
        value: 3334,
    },
    {
        label: "Hamilton, ON",
        value: 3324,
    },
    {
        label: "Hampton, ON",
        value: 3335,
    },
    {
        label: "Hanmer",
        value: 3339,
    },
    {
        label: "Hannon",
        value: 3336,
    },
    {
        label: "Hanover",
        value: 3340,
    },
    {
        label: "Harbour Crest",
        value: 3341,
    },
    {
        label: "Harley",
        value: 3343,
    },
    {
        label: "Harriston",
        value: 3342,
    },
    {
        label: "Harrow",
        value: 3344,
    },
    {
        label: "Harrowsmith",
        value: 3345,
    },
    {
        label: "Harwood",
        value: 3578,
    },
    {
        label: "Hastings",
        value: 3346,
    },
    {
        label: "Havelock",
        value: 3348,
    },
    {
        label: "Hawkesbury",
        value: 3350,
    },
    {
        label: "Hawkestone",
        value: 3349,
    },
    {
        label: "Hawkesville",
        value: 3351,
    },
    {
        label: "Hearst",
        value: 3352,
    },
    {
        label: "Heidelberg",
        value: 3560,
    },
    {
        label: "Hensall",
        value: 3354,
    },
    {
        label: "Hepworth",
        value: 3356,
    },
    {
        label: "Highgate",
        value: 3358,
    },
    {
        label: "Hillsburgh, ON",
        value: 3221,
    },
    {
        label: "Hillsdale",
        value: 3331,
    },
    {
        label: "Hilton Beach",
        value: 3360,
    },
    {
        label: "Holland Centre",
        value: 3347,
    },
    {
        label: "Holland Landing",
        value: 3361,
    },
    {
        label: "Holstein",
        value: 3363,
    },
    {
        label: "Honeywood",
        value: 3353,
    },
    {
        label: "Hornby, ON",
        value: 3364,
    },
    {
        label: "Hornepayne",
        value: 3366,
    },
    {
        label: "Horning Mills",
        value: 3359,
    },
    {
        label: "Huntsville",
        value: 3362,
    },
    {
        label: "Huron Park",
        value: 3367,
    },
    {
        label: "Hyde Park",
        value: 3368,
    },
    {
        label: "Ignace",
        value: 3372,
    },
    {
        label: "Ilderton",
        value: 3355,
    },
    {
        label: "Ingersoll",
        value: 3380,
    },
    {
        label: "Ingleside",
        value: 3374,
    },
    {
        label: "Inglewood",
        value: 3376,
    },
    {
        label: "Innerkip",
        value: 3378,
    },
    {
        label: "Innisfil",
        value: 3357,
    },
    {
        label: "Inverary",
        value: 3591,
    },
    {
        label: "Inwood",
        value: 3371,
    },
    {
        label: "Iona Station",
        value: 3365,
    },
    {
        label: "Iron Bridge",
        value: 3382,
    },
    {
        label: "Iroquois",
        value: 3384,
    },
    {
        label: "Iroquois Falls",
        value: 3386,
    },
    {
        label: "Islington",
        value: 3387,
    },
    {
        label: "Jackson's Point",
        value: 3388,
    },
    {
        label: "Janetville",
        value: 3593,
    },
    {
        label: "Jarvis",
        value: 3390,
    },
    {
        label: "Jerseyville",
        value: 3389,
    },
    {
        label: "Jordan",
        value: 3395,
    },
    {
        label: "Kagawong",
        value: 3391,
    },
    {
        label: "Kakabeka Falls",
        value: 3393,
    },
    {
        label: "Kaministiquia",
        value: 3392,
    },
    {
        label: "Kanata",
        value: 3394,
    },
    {
        label: "Kapuskasing",
        value: 3400,
    },
    {
        label: "Kars",
        value: 3369,
    },
    {
        label: "Kearney",
        value: 3402,
    },
    {
        label: "Keene",
        value: 3403,
    },
    {
        label: "Keewatin",
        value: 3404,
    },
    {
        label: "Kemble",
        value: 3405,
    },
    {
        label: "Kemptville",
        value: 3406,
    },
    {
        label: "Kenilworth",
        value: 3401,
    },
    {
        label: "Kenora",
        value: 3408,
    },
    {
        label: "Kent Bridge",
        value: 3409,
    },
    {
        label: "Kerwood",
        value: 3411,
    },
    {
        label: "Keswick",
        value: 3415,
    },
    {
        label: "Kettleby",
        value: 3417,
    },
    {
        label: "Kilbride, ON",
        value: 3373,
    },
    {
        label: "Killaloe",
        value: 3410,
    },
    {
        label: "Kinburn",
        value: 3407,
    },
    {
        label: "Kincardine",
        value: 3412,
    },
    {
        label: "Kincourt",
        value: 3419,
    },
    {
        label: "King",
        value: 3413,
    },
    {
        label: "King City",
        value: 3422,
    },
    {
        label: "Kingston, ON",
        value: 3414,
    },
    {
        label: "Kingsville, ON",
        value: 3416,
    },
    {
        label: "Kinmount",
        value: 3594,
    },
    {
        label: "Kippen",
        value: 3595,
    },
    {
        label: "Kirkland Lake",
        value: 3418,
    },
    {
        label: "Kitchener",
        value: 3420,
    },
    {
        label: "Kleinburg",
        value: 3424,
    },
    {
        label: "Komoka",
        value: 3426,
    },
    {
        label: "La Broquerie",
        value: 3430,
    },
    {
        label: "La Salette",
        value: 3431,
    },
    {
        label: "Ladner Lake",
        value: 3441,
    },
    {
        label: "Lake St. Peter",
        value: 3434,
    },
    {
        label: "Lakefield",
        value: 3442,
    },
    {
        label: "Lambeth",
        value: 3436,
    },
    {
        label: "Lanark",
        value: 3444,
    },
    {
        label: "Lancaster, ON",
        value: 3446,
    },
    {
        label: "Langton",
        value: 3438,
    },
    {
        label: "Lansdowne",
        value: 3447,
    },
    {
        label: "LaSalle, ON",
        value: 3433,
    },
    {
        label: "Latchford",
        value: 3448,
    },
    {
        label: "Leamington",
        value: 3450,
    },
    {
        label: "Leaside",
        value: 3451,
    },
    {
        label: "Leaskdale",
        value: 3453,
    },
    {
        label: "Lefaivre",
        value: 3432,
    },
    {
        label: "Lefroy",
        value: 3449,
    },
    {
        label: "Levack",
        value: 3452,
    },
    {
        label: "Limehouse",
        value: 3457,
    },
    {
        label: "Lincoln",
        value: 3454,
    },
    {
        label: "Lindsay",
        value: 3456,
    },
    {
        label: "Linwood",
        value: 3459,
    },
    {
        label: "Lion's Head",
        value: 3458,
    },
    {
        label: "Listowel",
        value: 3460,
    },
    {
        label: "Little Britain",
        value: 3375,
    },
    {
        label: "Little Current",
        value: 3462,
    },
    {
        label: "Lively",
        value: 3464,
    },
    {
        label: "Lombardy",
        value: 3465,
    },
    {
        label: "Londesborough",
        value: 3377,
    },
    {
        label: "London",
        value: 3466,
    },
    {
        label: "Long Branch",
        value: 3467,
    },
    {
        label: "Long Sault",
        value: 3469,
    },
    {
        label: "Longlac",
        value: 3379,
    },
    {
        label: "Lorette, ON",
        value: 3471,
    },
    {
        label: "L'Orignal",
        value: 3440,
    },
    {
        label: "Loring",
        value: 3946,
    },
    {
        label: "Lucan",
        value: 3468,
    },
    {
        label: "Lucknow",
        value: 3470,
    },
    {
        label: "Lynden",
        value: 3472,
    },
    {
        label: "Maberly",
        value: 3476,
    },
    {
        label: "Mactier",
        value: 3478,
    },
    {
        label: "Madoc",
        value: 3480,
    },
    {
        label: "Magnetawan",
        value: 3482,
    },
    {
        label: "Maidstone, ON",
        value: 3483,
    },
    {
        label: "Maitland",
        value: 3485,
    },
    {
        label: "Mallorytown, ON",
        value: 3223,
    },
    {
        label: "Malton",
        value: 3477,
    },
    {
        label: "Manitouwadge",
        value: 3487,
    },
    {
        label: "Manotick",
        value: 3489,
    },
    {
        label: "Mansfield",
        value: 3491,
    },
    {
        label: "Maple",
        value: 3493,
    },
    {
        label: "Marathon",
        value: 3479,
    },
    {
        label: "Markdale",
        value: 3484,
    },
    {
        label: "Markham",
        value: 3486,
    },
    {
        label: "Markstay",
        value: 3561,
    },
    {
        label: "Marmora",
        value: 3488,
    },
    {
        label: "Massey",
        value: 3490,
    },
    {
        label: "Mattawa",
        value: 3492,
    },
    {
        label: "Maxville",
        value: 3494,
    },
    {
        label: "Maynooth",
        value: 3481,
    },
    {
        label: "McGregor",
        value: 3495,
    },
    {
        label: "Mckellar",
        value: 3381,
    },
    {
        label: "Meaford",
        value: 3496,
    },
    {
        label: "Merlin",
        value: 3497,
    },
    {
        label: "Merrickville",
        value: 3498,
    },
    {
        label: "Metcalfe",
        value: 3383,
    },
    {
        label: "Midhurst",
        value: 3499,
    },
    {
        label: "Midland",
        value: 3500,
    },
    {
        label: "Mildmay",
        value: 3502,
    },
    {
        label: "Milford",
        value: 3385,
    },
    {
        label: "Millbank",
        value: 3268,
    },
    {
        label: "Millbrook",
        value: 3504,
    },
    {
        label: "Miller Lake",
        value: 9103,
    },
    {
        label: "Millgrove",
        value: 3264,
    },
    {
        label: "Milton",
        value: 3506,
    },
    {
        label: "Milverton",
        value: 3508,
    },
    {
        label: "Mimico",
        value: 3509,
    },
    {
        label: "Mindemoya",
        value: 3596,
    },
    {
        label: "Minden",
        value: 3507,
    },
    {
        label: "Minesing",
        value: 3396,
    },
    {
        label: "Missanabie",
        value: 3511,
    },
    {
        label: "Mississauga",
        value: 3510,
    },
    {
        label: "Mitchell, ON",
        value: 3512,
    },
    {
        label: "Moffat",
        value: 3397,
    },
    {
        label: "Monkton",
        value: 3503,
    },
    {
        label: "Monteith",
        value: 3996,
    },
    {
        label: "Moonbeam",
        value: 3505,
    },
    {
        label: "Moorefield",
        value: 3513,
    },
    {
        label: "Moose Factory",
        value: 3501,
    },
    {
        label: "Moosonee",
        value: 3515,
    },
    {
        label: "Morrisburg",
        value: 3514,
    },
    {
        label: "Morriston",
        value: 3597,
    },
    {
        label: "Mount Albert",
        value: 3518,
    },
    {
        label: "Mount Brydges",
        value: 3517,
    },
    {
        label: "Mount Elgin",
        value: 3949,
    },
    {
        label: "Mount Forest",
        value: 3516,
    },
    {
        label: "Mount Hope",
        value: 3330,
    },
    {
        label: "Mount Pleasant",
        value: 3519,
    },
    {
        label: "Mountain",
        value: 3520,
    },
    {
        label: "Muirkirk",
        value: 3521,
    },
    {
        label: "Murillo",
        value: 3950,
    },
    {
        label: "Nairn",
        value: 3522,
    },
    {
        label: "Nakina",
        value: 3524,
    },
    {
        label: "Nannon",
        value: 3525,
    },
    {
        label: "Nanticoke",
        value: 3526,
    },
    {
        label: "Napanee",
        value: 3530,
    },
    {
        label: "Navan",
        value: 3528,
    },
    {
        label: "Nepean",
        value: 3531,
    },
    {
        label: "Nestor Falls",
        value: 3529,
    },
    {
        label: "Neustadt",
        value: 3532,
    },
    {
        label: "New Dundee",
        value: 3533,
    },
    {
        label: "New Hamburg",
        value: 3534,
    },
    {
        label: "New Liskeard",
        value: 3536,
    },
    {
        label: "New Lowell",
        value: 3537,
    },
    {
        label: "Newboro",
        value: 3538,
    },
    {
        label: "Newburgh",
        value: 3540,
    },
    {
        label: "Newbury",
        value: 3542,
    },
    {
        label: "Newcastle, ON",
        value: 3544,
    },
    {
        label: "Newmarket",
        value: 3546,
    },
    {
        label: "Newtonville",
        value: 3547,
    },
    {
        label: "Niagara Falls",
        value: 3548,
    },
    {
        label: "Niagara-on-the-Lake",
        value: 3550,
    },
    {
        label: "Nipigon",
        value: 3543,
    },
    {
        label: "Nobel",
        value: 3598,
    },
    {
        label: "Nobleton",
        value: 3549,
    },
    {
        label: "North Augusta",
        value: 3551,
    },
    {
        label: "North Bay",
        value: 3552,
    },
    {
        label: "North Gower",
        value: 3545,
    },
    {
        label: "North York",
        value: 3827,
    },
    {
        label: "Norval",
        value: 3553,
    },
    {
        label: "Norwich",
        value: 3554,
    },
    {
        label: "Norwick",
        value: 3556,
    },
    {
        label: "Norwood",
        value: 3557,
    },
    {
        label: "Nottawa",
        value: 3527,
    },
    {
        label: "Novar",
        value: 3562,
    },
    {
        label: "Oakland",
        value: 3370,
    },
    {
        label: "Oakville",
        value: 3580,
    },
    {
        label: "Oil Springs",
        value: 3582,
    },
    {
        label: "Oldcastle",
        value: 3579,
    },
    {
        label: "Oliphant",
        value: 3581,
    },
    {
        label: "Omemee",
        value: 3584,
    },
    {
        label: "Ompah",
        value: 3583,
    },
    {
        label: "Orangeville",
        value: 3586,
    },
    {
        label: "Orillia",
        value: 3588,
    },
    {
        label: "Orleans",
        value: 3585,
    },
    {
        label: "Orono",
        value: 3258,
    },
    {
        label: "Orton",
        value: 3587,
    },
    {
        label: "Osgoode",
        value: 3589,
    },
    {
        label: "Oshawa",
        value: 3590,
    },
    {
        label: "Ospringe",
        value: 3592,
    },
    {
        label: "Other",
        value: 4999,
    },
    {
        label: "Ottawa",
        value: 3600,
    },
    {
        label: "Otterville, ON",
        value: 3606,
    },
    {
        label: "Owen Sound",
        value: 3610,
    },
    {
        label: "Oxford County",
        value: 3609,
    },
    {
        label: "Oxford Mills",
        value: 3608,
    },
    {
        label: "Oxford, ON",
        value: 3607,
    },
    {
        label: "Oxley",
        value: 3611,
    },
    {
        label: "Paisley",
        value: 3620,
    },
    {
        label: "Palgrave",
        value: 3621,
    },
    {
        label: "Palmerston",
        value: 3622,
    },
    {
        label: "Paris",
        value: 3624,
    },
    {
        label: "Parkdale, ON",
        value: 3625,
    },
    {
        label: "Parkhill",
        value: 3626,
    },
    {
        label: "Parry Sound",
        value: 3628,
    },
    {
        label: "Pass Lake",
        value: 3563,
    },
    {
        label: "Pefferlaw",
        value: 3629,
    },
    {
        label: "Pelham",
        value: 3630,
    },
    {
        label: "Pembroke",
        value: 3632,
    },
    {
        label: "Penetang",
        value: 3633,
    },
    {
        label: "Penetanguishene",
        value: 3634,
    },
    {
        label: "Perkinsfield",
        value: 3635,
    },
    {
        label: "Perrault Falls",
        value: 3463,
    },
    {
        label: "Perth Road",
        value: 3564,
    },
    {
        label: "Perth, ON",
        value: 3636,
    },
    {
        label: "Petawawa",
        value: 3638,
    },
    {
        label: "Peterborough",
        value: 3640,
    },
    {
        label: "Petersburg",
        value: 3641,
    },
    {
        label: "Petrolia",
        value: 3642,
    },
    {
        label: "Phelpston",
        value: 3398,
    },
    {
        label: "Pickering",
        value: 3644,
    },
    {
        label: "Picton, ON",
        value: 3646,
    },
    {
        label: "Pigeon Lake",
        value: 3947,
    },
    {
        label: "Plantagenet",
        value: 3648,
    },
    {
        label: "Plattsville",
        value: 3649,
    },
    {
        label: "Plevna",
        value: 3647,
    },
    {
        label: "Point Edward",
        value: 3650,
    },
    {
        label: "Pointe au Baril",
        value: 3643,
    },
    {
        label: "Pontypool",
        value: 3645,
    },
    {
        label: "Porcupine",
        value: 3651,
    },
    {
        label: "Port Burwell",
        value: 3652,
    },
    {
        label: "Port Cambton",
        value: 3655,
    },
    {
        label: "Port Carling",
        value: 3653,
    },
    {
        label: "Port Colborne",
        value: 3654,
    },
    {
        label: "Port Credit",
        value: 3656,
    },
    {
        label: "Port Dover",
        value: 3658,
    },
    {
        label: "Port Elgin, ON",
        value: 3660,
    },
    {
        label: "Port Franks",
        value: 3399,
    },
    {
        label: "Port Hope",
        value: 3662,
    },
    {
        label: "Port Lambton",
        value: 3663,
    },
    {
        label: "Port McNicoll",
        value: 3664,
    },
    {
        label: "Port Perry",
        value: 3666,
    },
    {
        label: "Port Rowan",
        value: 3668,
    },
    {
        label: "Port Severn",
        value: 3669,
    },
    {
        label: "Port Stanley",
        value: 3667,
    },
    {
        label: "Port Sydney",
        value: 3665,
    },
    {
        label: "Pottageville",
        value: 3421,
    },
    {
        label: "Powassan",
        value: 3670,
    },
    {
        label: "Prescott",
        value: 3672,
    },
    {
        label: "Princeton, ON",
        value: 3674,
    },
    {
        label: "Proton Station",
        value: 3675,
    },
    {
        label: "Puslinch",
        value: 3676,
    },
    {
        label: "Queenston",
        value: 3599,
    },
    {
        label: "Queensville",
        value: 3681,
    },
    {
        label: "Quibell",
        value: 3680,
    },
    {
        label: "Rainy River",
        value: 3690,
    },
    {
        label: "Ravenna",
        value: 3565,
    },
    {
        label: "Ravenswood",
        value: 3688,
    },
    {
        label: "Red Lake",
        value: 3689,
    },
    {
        label: "Red Rock",
        value: 3691,
    },
    {
        label: "Renfrew",
        value: 3692,
    },
    {
        label: "Rexdale",
        value: 3693,
    },
    {
        label: "Richards Landing",
        value: 3225,
    },
    {
        label: "Richmond Hill, ON",
        value: 3696,
    },
    {
        label: "Richmond, ON",
        value: 3694,
    },
    {
        label: "Ridgetown",
        value: 3698,
    },
    {
        label: "Ridgeville",
        value: 3699,
    },
    {
        label: "Ridgeway",
        value: 3701,
    },
    {
        label: "Ripley",
        value: 3700,
    },
    {
        label: "River Drive Park",
        value: 3423,
    },
    {
        label: "Rockcliffe Park",
        value: 3602,
    },
    {
        label: "Rockland",
        value: 3704,
    },
    {
        label: "Rockwood",
        value: 3703,
    },
    {
        label: "Rodney",
        value: 3706,
    },
    {
        label: "Roseneath",
        value: 3707,
    },
    {
        label: "Rossport",
        value: 3709,
    },
    {
        label: "Rousseau",
        value: 3708,
    },
    {
        label: "Russell, ON",
        value: 3710,
    },
    {
        label: "Ruthven",
        value: 3711,
    },
    {
        label: "Salford",
        value: 3713,
    },
    {
        label: "Saltfort",
        value: 3771,
    },
    {
        label: "Sarnia",
        value: 3714,
    },
    {
        label: "Sarsfield",
        value: 3566,
    },
    {
        label: "Sault Ste Marie",
        value: 3716,
    },
    {
        label: "Scarborough",
        value: 3829,
    },
    {
        label: "Schomberg",
        value: 3712,
    },
    {
        label: "Schreiber",
        value: 3715,
    },
    {
        label: "Schumacher",
        value: 3717,
    },
    {
        label: "Scotland",
        value: 3718,
    },
    {
        label: "Seaforth",
        value: 3720,
    },
    {
        label: "Seagrave",
        value: 3601,
    },
    {
        label: "Sebringville",
        value: 3773,
    },
    {
        label: "Seeleys Bay",
        value: 3719,
    },
    {
        label: "Selby",
        value: 3775,
    },
    {
        label: "Severn Bridge",
        value: 3721,
    },
    {
        label: "Shakespeare",
        value: 3737,
    },
    {
        label: "Shallow Lake",
        value: 3722,
    },
    {
        label: "Shanty Bay",
        value: 3776,
    },
    {
        label: "Sharon",
        value: 3723,
    },
    {
        label: "Sheguiandah",
        value: 3425,
    },
    {
        label: "Shelburne, ON",
        value: 3724,
    },
    {
        label: "Sherkston",
        value: 3725,
    },
    {
        label: "Simcoe",
        value: 3726,
    },
    {
        label: "Singhampton",
        value: 3473,
    },
    {
        label: "Sioux Lookout",
        value: 3728,
    },
    {
        label: "Sioux Narrows",
        value: 3727,
    },
    {
        label: "Sleeman",
        value: 3729,
    },
    {
        label: "Smiths Falls",
        value: 3730,
    },
    {
        label: "Smithville",
        value: 3731,
    },
    {
        label: "Smooth Rock Falls",
        value: 3732,
    },
    {
        label: "Sombra",
        value: 3756,
    },
    {
        label: "South Porcupine",
        value: 3733,
    },
    {
        label: "South Portage",
        value: 3735,
    },
    {
        label: "South River, ON",
        value: 3734,
    },
    {
        label: "South Wold",
        value: 3948,
    },
    {
        label: "South Woodslee",
        value: 3428,
    },
    {
        label: "Southampton",
        value: 3736,
    },
    {
        label: "Spencerville",
        value: 3777,
    },
    {
        label: "Spring Bay",
        value: 3778,
    },
    {
        label: "Springfield, ON",
        value: 3738,
    },
    {
        label: "St Catharines",
        value: 3740,
    },
    {
        label: "St Clair Beach",
        value: 3742,
    },
    {
        label: "St Davids",
        value: 3567,
    },
    {
        label: "St George",
        value: 3260,
    },
    {
        label: "St Mary's",
        value: 3746,
    },
    {
        label: "St Thomas",
        value: 3748,
    },
    {
        label: "St. Agatha",
        value: 3745,
    },
    {
        label: "St. Andrews West",
        value: 3429,
    },
    {
        label: "St. Ann's",
        value: 3739,
    },
    {
        label: "St. Bernardin",
        value: 3741,
    },
    {
        label: "St. Charles, ON",
        value: 3743,
    },
    {
        label: "St. Isidore",
        value: 3744,
    },
    {
        label: "St. Paul, ON",
        value: 3747,
    },
    {
        label: "St. Williams",
        value: 3749,
    },
    {
        label: "Staffa",
        value: 3751,
    },
    {
        label: "Stayner",
        value: 3750,
    },
    {
        label: "Stevensville",
        value: 3753,
    },
    {
        label: "Stirling, ON",
        value: 3752,
    },
    {
        label: "Stittsville",
        value: 3754,
    },
    {
        label: "Stoney Creek",
        value: 3332,
    },
    {
        label: "Stoney Point",
        value: 3755,
    },
    {
        label: "Stouffville",
        value: 3922,
    },
    {
        label: "Stratffordville",
        value: 3759,
    },
    {
        label: "Stratford, ON",
        value: 3758,
    },
    {
        label: "Strathroy",
        value: 3760,
    },
    {
        label: "Stratton",
        value: 3757,
    },
    {
        label: "Streetford",
        value: 3761,
    },
    {
        label: "Streetsville",
        value: 3762,
    },
    {
        label: "Stroud",
        value: 3763,
    },
    {
        label: "Strudberry",
        value: 3765,
    },
    {
        label: "Sturgeon Falls",
        value: 3764,
    },
    {
        label: "Sturgeon Lake",
        value: 3767,
    },
    {
        label: "Sturgeon Point",
        value: 3766,
    },
    {
        label: "Sudbury",
        value: 3768,
    },
    {
        label: "Sunderland",
        value: 3769,
    },
    {
        label: "Sundridge",
        value: 3770,
    },
    {
        label: "Sutton West",
        value: 3774,
    },
    {
        label: "Sutton, ON",
        value: 3772,
    },
    {
        label: "Tara",
        value: 3780,
    },
    {
        label: "Tavistock",
        value: 3782,
    },
    {
        label: "Tecumseh",
        value: 3784,
    },
    {
        label: "Teeswater",
        value: 3786,
    },
    {
        label: "Terra Cotta",
        value: 3785,
    },
    {
        label: "Terrace Bay",
        value: 3787,
    },
    {
        label: "Teviotdale",
        value: 3789,
    },
    {
        label: "Thamesford, ON",
        value: 3227,
    },
    {
        label: "Thamesville",
        value: 3788,
    },
    {
        label: "Thedford, ON",
        value: 3790,
    },
    {
        label: "Thessalon",
        value: 3792,
    },
    {
        label: "Thornbury",
        value: 3794,
    },
    {
        label: "Thorndale",
        value: 3795,
    },
    {
        label: "Thornhill",
        value: 3793,
    },
    {
        label: "Thornloe",
        value: 3796,
    },
    {
        label: "Thornton",
        value: 3791,
    },
    {
        label: "Thorold",
        value: 3798,
    },
    {
        label: "Thunder Bay",
        value: 3800,
    },
    {
        label: "Tilbury",
        value: 3802,
    },
    {
        label: "Tillsonburg",
        value: 3804,
    },
    {
        label: "Timmins",
        value: 3806,
    },
    {
        label: "Tiverton",
        value: 3808,
    },
    {
        label: "Tobermory",
        value: 3810,
    },
    {
        label: "Toledo",
        value: 3811,
    },
    {
        label: "Toronto",
        value: 3812,
    },
    {
        label: "Tottenham",
        value: 3842,
    },
    {
        label: "Trenton, ON",
        value: 3844,
    },
    {
        label: "Trout Creek",
        value: 3846,
    },
    {
        label: "Turkey Point",
        value: 3847,
    },
    {
        label: "Tweed",
        value: 3848,
    },
    {
        label: "Unionville",
        value: 3856,
    },
    {
        label: "Utopia",
        value: 3858,
    },
    {
        label: "Uxbridge",
        value: 3860,
    },
    {
        label: "Val Caron",
        value: 3866,
    },
    {
        label: "Vanessa",
        value: 3868,
    },
    {
        label: "Vanier, ON",
        value: 3870,
    },
    {
        label: "Vankleek Hill",
        value: 3872,
    },
    {
        label: "Vars",
        value: 3247,
    },
    {
        label: "Vaughan",
        value: 3874,
    },
    {
        label: "Vermillion Bay",
        value: 3875,
    },
    {
        label: "Victoria Harbour",
        value: 3876,
    },
    {
        label: "Vienna",
        value: 3878,
    },
    {
        label: "Vineland",
        value: 3880,
    },
    {
        label: "Virgil",
        value: 3882,
    },
    {
        label: "Virginiatown",
        value: 3884,
    },
    {
        label: "Vittoria",
        value: 3885,
    },
    {
        label: "Wahnapitae",
        value: 3435,
    },
    {
        label: "Wainfleet",
        value: 3886,
    },
    {
        label: "Waldhof",
        value: 3888,
    },
    {
        label: "Walkerton",
        value: 3890,
    },
    {
        label: "Wallaceburg",
        value: 3892,
    },
    {
        label: "Wallenstein",
        value: 3887,
    },
    {
        label: "Walsingham",
        value: 3889,
    },
    {
        label: "Walton, ON",
        value: 3891,
    },
    {
        label: "Wardsville",
        value: 3894,
    },
    {
        label: "Warkworth",
        value: 3603,
    },
    {
        label: "Warminster",
        value: 3895,
    },
    {
        label: "Warren, ON",
        value: 3893,
    },
    {
        label: "Warsaw",
        value: 3474,
    },
    {
        label: "Wasaga Beach",
        value: 3896,
    },
    {
        label: "Washago",
        value: 3897,
    },
    {
        label: "Waterdown",
        value: 3899,
    },
    {
        label: "Waterford",
        value: 3898,
    },
    {
        label: "Waterloo, ON",
        value: 3900,
    },
    {
        label: "Watertown",
        value: 3901,
    },
    {
        label: "Watford",
        value: 3902,
    },
    {
        label: "Waubaushene",
        value: 3437,
    },
    {
        label: "Wawa",
        value: 3904,
    },
    {
        label: "Webbwood",
        value: 3906,
    },
    {
        label: "Welland",
        value: 3908,
    },
    {
        label: "Wellandport",
        value: 3907,
    },
    {
        label: "Wellesley",
        value: 3910,
    },
    {
        label: "Wellington, ON",
        value: 3912,
    },
    {
        label: "Wendover",
        value: 3475,
    },
    {
        label: "West Lorne",
        value: 3914,
    },
    {
        label: "Westhill",
        value: 3913,
    },
    {
        label: "Westmeath",
        value: 3523,
    },
    {
        label: "Weston",
        value: 3915,
    },
    {
        label: "Westport",
        value: 3916,
    },
    {
        label: "Westwood",
        value: 3917,
    },
    {
        label: "Wheatley",
        value: 3918,
    },
    {
        label: "Whitby",
        value: 3920,
    },
    {
        label: "White Lake",
        value: 3909,
    },
    {
        label: "Whitefish",
        value: 3923,
    },
    {
        label: "Whitevale",
        value: 3262,
    },
    {
        label: "Wiarton",
        value: 3911,
    },
    {
        label: "Williamsford",
        value: 3919,
    },
    {
        label: "Williamstown",
        value: 3921,
    },
    {
        label: "Willow Beach",
        value: 3604,
    },
    {
        label: "Willowdale",
        value: 3925,
    },
    {
        label: "Wilno",
        value: 3443,
    },
    {
        label: "Wilsonville",
        value: 3927,
    },
    {
        label: "Winchester",
        value: 3926,
    },
    {
        label: "Windsor, ON",
        value: 3928,
    },
    {
        label: "Wingham",
        value: 3930,
    },
    {
        label: "Winona",
        value: 3931,
    },
    {
        label: "Woodbridge",
        value: 3933,
    },
    {
        label: "Woodham",
        value: 3903,
    },
    {
        label: "Woodlawn",
        value: 3445,
    },
    {
        label: "Woodstock, ON",
        value: 3932,
    },
    {
        label: "Woodville",
        value: 3934,
    },
    {
        label: "Worwood",
        value: 3558,
    },
    {
        label: "Wroxeter",
        value: 3929,
    },
    {
        label: "Wyebridge",
        value: 3937,
    },
    {
        label: "Wyevale",
        value: 3455,
    },
    {
        label: "Wyoming",
        value: 3936,
    },
    {
        label: "Yarker",
        value: 3938,
    },
    {
        label: "York",
        value: 3838,
    },
    {
        label: "York Mills",
        value: 3839,
    },
    {
        label: "Zephyr",
        value: 3939,
    },
    {
        label: "Zurich",
        value: 3940,
    },
];
